module.exports = __webpack_public_path__ + "img/btn_follow_on.1855f112.svg";